// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bpmn-container[data-v-655c9c0f]{width:100%;height:100%;display:inline-grid;grid-template-columns:100px auto -webkit-max-content;grid-template-columns:100px auto max-content}", ""]);
// Exports
module.exports = exports;
